import { FC } from 'react';
import styled from '@emotion/styled';
import { Card } from '@material-ui/core';
import _PeopleIcon from '@material-ui/icons/PeopleOutlined';
import _MoneyIcon from '@material-ui/icons/Money';
import _DesktopIcon from '@material-ui/icons/DesktopMac';
import Spinner from '../../primitive/Spinner';

type Props = {
  className?: string;
};

const Loading: FC<Props> = ({ className }) => (
  <Root className={className}>
    {/* <CardContent> */}
    <OriginalSpinner size={24} width={'auto'} />
    {/* </CardContent> */}
  </Root>
);

const Root = styled(Card)({
  height: '100%',
});

const OriginalSpinner = styled(Spinner)({
  height: '100%',
});

export default Loading;
